// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__TZRL0","rootSmall":"AddTileButton_rootSmall__2mNCs"};